module.exports = __webpack_public_path__ + "img/43_65.f904e075.png";